export const DecorativeLines = ({ variant = "curves" }) => {
  const baseClass = "hidden lg:block absolute overflow-hidden pointer-events-none";

  if (variant === "hero-shape") {
    const fadeStyle = {
      WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 35%)",
      maskImage: "linear-gradient(to right, transparent 0%, black 35%)",
    };
    return (
      <div className={`${baseClass} top-0 right-0 h-full w-full`}>
        <img
          src="/serce.svg"
          alt=""
          style={fadeStyle}
          className="absolute top-8 right-4 w-[700px] h-auto opacity-80 dark:hidden"
        />
        <img
          src="/serce-dark.svg"
          alt=""
          style={fadeStyle}
          className="absolute top-8 right-4 w-[700px] h-auto hidden dark:block dark:opacity-40"
        />
      </div>
    );
  }

  if (variant === "curves-left") {
    return (
      <div className={`${baseClass} inset-0`}>
        <svg width="100%" height="100%" viewBox="0 0 1200 800" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M280,0 Q250,150 0,350"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-50 dark:opacity-30"
          />
        </svg>
        <svg width="100%" height="100%" viewBox="0 0 1600 1200" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0">
          <path
            d="M0,400 Q600,350 0,900"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-40 dark:opacity-25"
          />
        </svg>
      </div>
    );
  }

  if (variant === "curves-right") {
    return (
      <div className={`${baseClass} inset-0`}>
        <svg width="100%" height="100%" viewBox="0 0 1400 800" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1400,100 Q900,300 1400,700"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-45 dark:opacity-25"
          />
        </svg>
      </div>
    );
  }

  if (variant === "circles") {
    return (
      <div className={`${baseClass} inset-0`}>
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <circle
            r="400" cx="105%" cy="200"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-35 dark:opacity-20"
          />
          <circle
            r="300" cx="105%" cy="200"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-30 dark:opacity-15"
          />
        </svg>
        <svg width="100%" height="100%" viewBox="0 0 1400 1000" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0">
          <path
            d="M0,300 C500,800 900,900 1400,1200"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-35 dark:opacity-20"
          />
        </svg>
      </div>
    );
  }

  if (variant === "diagonal") {
    return (
      <div className={`${baseClass} inset-0`}>
        <svg width="100%" height="100%" viewBox="0 0 1900 1000" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M500,0 Q450,400 1100,900"
            fill="transparent"
            stroke="#EA8628"
            strokeWidth="2"
            className="opacity-40 dark:opacity-20"
          />
        </svg>
      </div>
    );
  }

  return null;
};
